import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { fetchAll as fetchAllSprint, update as updateSprintSub } from '../../subscriptions/sprint/actions';
import { fetchAll as fetchAllAtt, update as updateAttSub } from '../../subscriptions/att/actions';
import { fetchAll as fetchAllQuick, update as updateQuickSub } from '../../subscriptions/quick/actions';
import { getUser, getAllQuickSubscriptions, getAllAttSubscriptions, getAllSprintSubscriptions } from 'reducers';
import Box from 'common/Box';
import toggle_on from '../toggle/toggle_on.svg';
import toggle_off from '../toggle/toggle_off.svg';
import { formatMdn, getCarrier } from '../../helpers/subs';

import styles from './index.module.css';

class SmsNotifications extends React.Component {
  componentDidMount() {
    this.fetchSubs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchSubs();
    }
  }

  fetchSubs = () => {
    const { fetchAllSprint, fetchAllAtt, fetchAllQuick, userId } = this.props;
    if (userId) {
      fetchAllSprint(userId);
      fetchAllAtt(userId);
      fetchAllQuick(userId);
    }
  }

  handleToggleSubNotification = sub => {
    const { updateSprintSub, updateAttSub, updateQuickSub } = this.props;
    const carrier = getCarrier(sub);
    const carrierToApi = {
      sprint: updateSprintSub,
      att: updateAttSub,
      quick: updateQuickSub,
    }

    const apiCall = carrierToApi[carrier];
    apiCall(sub.id, { sms_notifications: !sub.sms_notifications });
  }

  
  render() {
    const { sprintSubs, attSubs, quickSubs } = this.props;
    const allSubs = [...sprintSubs, ...attSubs, ...quickSubs];

    if (allSubs.length === 0) {
      return null;
    }

    return (
      <div className={styles.wrapper}>
        <h2 className={styles.title}>SMS Notifications</h2>
        <Box>
          <p className={styles.text}>
            By disabling, you might miss important texts about your account or data usage. You'll still receive email notifications.
          </p>
          <div className={styles.line}></div>
          <ul className={styles.list}>
            {allSubs.map(sub => (
              <li key={sub.id} className={styles.sub}>
                <div className={styles.subInfo}><span><b>{sub.first_name} {sub.last_name}</b></span> <span>{formatMdn(sub.mdn)}</span></div>
                <div className={styles.toggleWrapper}>
                  <span className={styles.toggleStatus}>{sub.sms_notifications ? 'ON' : 'OFF'}</span>
                  <span
                    className={cn(styles.toggle, sub.sms_notifications ? styles.on : styles.off)}
                    onClick={() => this.handleToggleSubNotification(sub)}
                  >
                    {sub.sms_notifications ?
                      <img src={toggle_on} alt="" />
                      :
                      <img src={toggle_off} alt="" />
                    }
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </Box>
      </div>
    );
  }
}        

const mapStateToProps = (state) => ({
  userId: getUser(state) && getUser(state).id,
  sprintSubs: getAllSprintSubscriptions(state),
  attSubs: getAllAttSubscriptions(state),
  quickSubs: getAllQuickSubscriptions(state),
});

const mapDispatchToProps = {
  fetchAllSprint,
  fetchAllAtt,
  fetchAllQuick,
  updateSprintSub,
  updateAttSub,
  updateQuickSub,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsNotifications);
